import Vue from 'vue'
import Vuex from 'vuex'
import offers from './offers'
import schoolOffers from './schoolOffers'
import shixiOffers from './shixiOffers'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        allCount: '10000',
        tabInfo: {
            one: '',
            two: ''
        },
        isMobile: false, // 定义屏幕大小小于768px为手机
        lang: 'CN', // CN中文，EN英文
        solutions: [{
            id: 'airPort',
            label: 'newSolutions.data.airPort',
            children: [{
                id: 'tarmac',
                // label: 'newSolutions.data.tarmac'
            }]
        },
        {
            id: 'education',
            label: 'newSolutions.data.education',
            children: [{
                id: 'campus',
                // label: 'newSolutions.data.campus'
            }]
        },
        {
            id: 'park',
            label: 'newSolutions.data.park',
            children: [{
                id: 'publicPark',
                label: 'newSolutions.data.publicPark'
            }]
        },

        {
            id: 'detection',
            label: 'newSolutions.data.detection',
            children: [{
                id: 'measurement',
                label: 'newSolutions.data.measurement'
            },
            {
                id: 'steel',
                label: 'newSolutions.data.steel'
            }
            ]
        },
        {
            id: 'traffic',
            label: 'newSolutions.data.traffic',
            children: []
        },
        // {
        //     id: 'medical',
        //     label: 'newSolutions.data.medical',
        //     children: [{
        //         id: 'itm',
        //         label: 'newSolutions.data.itm'
        //     }]
        // },
        {
            id: 'port',
            label: 'newSolutions.data.port'
        }
        ],
        offers:offers, //社招职位
        schoolOffers:schoolOffers, //校招职位
        shixiOffers: shixiOffers,//实习
    },
    getters: {
        offers: state => {
            return state.offers;
        },
        oneTab: state => {
            return state.tabInfo.one
        },
        twoTab: state => {
            return state.tabInfo.two
        },
        isMobile: state => {
            return state.isMobile
        },
        lang: state => {
            return state.lang
        },
        solutions: state => {
            return state.solutions
        },
        allCount: state => {
            return state.allCount
        }
    },
    mutations: {
        setTabInfo(state, tabInfo) {
            state.tabInfo = tabInfo
        },
        setIsMobile(state, isMobile) {
            state.isMobile = isMobile;
        },
        setLang(state, lang) {
            state.lang = lang
        },
        setAllCount(state, allCount) {
            state.allCount = allCount
        },
    },
    actions: {
        setIsMobile(state, isMobile) {
            // console.log(isMobile, '&&&&&')
            state.commit('setIsMobile', isMobile)
        },
        setLang(state, lang) {
            console.log(lang, '&&&&&')
            state.commit('setLang', lang)
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/store.js